/**
 * The types of the buttons.
 */
export var BUTTON_TYPES;
(function (BUTTON_TYPES) {
    BUTTON_TYPES["DESTRUCTIVE"] = "destructive";
    BUTTON_TYPES["PRIMARY"] = "primary";
    BUTTON_TYPES["SECONDARY"] = "secondary";
    BUTTON_TYPES["TERTIARY"] = "tertiary";
})(BUTTON_TYPES || (BUTTON_TYPES = {}));
export var BUTTON_SIZES;
(function (BUTTON_SIZES) {
    BUTTON_SIZES["TINY"] = "tiny";
    BUTTON_SIZES["SMALL"] = "small";
    BUTTON_SIZES["MEDIUM"] = "medium";
    BUTTON_SIZES["LARGE"] = "large";
})(BUTTON_SIZES || (BUTTON_SIZES = {}));
/**
 * Behaviour types for showing overflow text content.
 */
export var TEXT_OVERFLOW_TYPES;
(function (TEXT_OVERFLOW_TYPES) {
    TEXT_OVERFLOW_TYPES["ELLIPSIS"] = "ellipsis";
    TEXT_OVERFLOW_TYPES["SCROLL_ON_HOVER"] = "scroll-on-hover";
})(TEXT_OVERFLOW_TYPES || (TEXT_OVERFLOW_TYPES = {}));
/**
 * The modes of the buttons.
 */
export const BUTTON_MODES = {
    CONTAINED: 'contained',
    TEXT: 'text'
};
export const TOTAL_MENU_WIDTH = 350;
export const TOTAL_HEADER_FEEDBACK_HEIGHT = 88;
/**
 * clase name of size form control label
 */
export const FORM_CONTROL_LABEL_SIZE_CLASS = {
    MEDIUM: 'from-medium',
    SMALL: 'form-small'
};
